/*
 * @Author: LiuLiXue QQ:136890965 
 * @Date: 2017-12-22 15:57:52 
 * @Last Modified by: aLeng
 * @Last Modified time: 2018-02-28 15:03:48
 */
//用户权限弹框

<template>
  <el-dialog class="dialog-wrap"  
    :visible.sync="visible"
    :before-close="handleClose"  
    >
    <div class="title" slot='title' v-text="title"></div>
    <div class="border"></div>
    <el-form v-if="showForm" ref="form" :rules="rules" :model="form" :label-width="formLabelWidth" label-position="left">
      <el-form-item prop="roleName">
        <span class="label" slot="label">
          角色名称
        </span>
        <el-input
          v-model="form.roleName"
          placeholder="请输入角色名称(10个字以内)"
        />
      </el-form-item>
    </el-form>
    <div class="checkWrap">
      <div class="title pre">
        <span class="xing">*</span>
        权限分配
      </div>
      <el-tree
        :data="data"
        show-checkbox       
        :props="defaultProps"       
        ref="tree"
        node-key="id"
        :default-checked-keys="defaultChecked"
      >
      </el-tree>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="_cancel">取 消</el-button>
      <el-button class="sure" @click="_sure">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCookie } from "@/utils/common";
import { toTreeData } from "./toTreeData";
let _fn = f => f;
export default {
  name: "perBox",
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    defaultChecked: {
      type: Array,
      default() {
        return [];
      }
    },
    roleInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    showForm: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: "修改用户权限"
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const checkLength = (rule, value, callback) => {
      if(!value) {
        return callback(new Error('角色名称不能为空'))
      } else {
        if( value.length > 10) {
          return callback(new Error('角色名称过长,请限制在10字以内'))
        }else{
          callback()
        }
      }
    }
    return {
      id: "id",
      // data: [],
      checkedIds: [],
      setChecked: null,
      dialogTableVisible: false,
      dialogFormVisible: false,
      formLabelWidth: "100px",
      roleId: "",
      isEdit: false,
      defaultProps: {
        children: "children",
        label: "name",
        disabled: "disabled"
      },
      form: {
        roleName: ""
      },
      rules: {
        roleName: [{validator: checkLength, trigger: "blur" }]
      }
    };
  },
  watch: {
    roleInfo(newValue) {
      if (newValue.roleName) {
        this.form["roleName"] = newValue.roleName;
        this.isEdit = true;
        this.roleId = newValue.roleId;
      } else {
        this.form["roleName"] = "";
      }
    },
    defaultChecked(newValue) {
      if (this.$refs.tree) {
        let fn = this.$refs.tree.setCheckedKeys;
        fn(newValue);
      }
    }
  },
  
  methods: {
    handleClose(done) {
      
      this.$confirm("确认关闭？")
        .then(() => {
          this.$emit('cancel')
        })
        .catch(() => {
          this.$emit("noClosed");
        });
    },
    _cancel() {
      this.$emit("cancel");
    },
    _sure() {
      let choiceIds = this._getCheckedKey();
      if (!this.showForm) {
        this.$emit("sure", choiceIds);
      } else {
        this.$refs.form.validate(valid => {
          if (valid) {
            let data = {};
            if (this.isEdit) {
              data = {
                roleId: this.roleId,
                menuId: choiceIds.join(","),
                roleName: this.form.roleName
              };
            } else {
              data = {
                menuId: choiceIds.join(","),
                roleName: this.form.roleName
              };
            }
            this.$emit("sure", data);
          }
        });
      }
    },
    _getCheckedKey() {
      const listFirstMenu = JSON.parse(getCookie("listFirstMenu"));
      const listSecondMenu = JSON.parse(getCookie("listsecondMenu"));
      const listThreeMenu = JSON.parse(getCookie("listThreeMenu"));
      const data = [...listFirstMenu, ...listSecondMenu, ...listThreeMenu];
      let nodes = this.$refs.tree.getCheckedNodes();
      let len = nodes.length;
      let length = data.length;
      let ids = [];
      const set = new Set();
      for (let i = 0; i < len; i++) {
        let pid = nodes[i].parentId;
        for (let p = 0; p < length; p++) {
          if (data[p].id == pid) {
            set.add(data[p].parentId);
          }
        }
        set.add(nodes[i].parentId);
        set.add(nodes[i].id);
      }
      ids = [...set].filter(value => {
        return value > 0;
      });
      return ids;
    }
  }
};
</script>

<style lang="scss" scoped>
$border-color: #e2e2e2;
%_font{
  font-size: 14px;
  color: #323232;
}
.dialog-wrap {
  .title{
    @extend %_font;
  }
  .border {
    margin: -30px -20px 20px;
    border-bottom: 1px solid $border-color;
  }
  .label{
    @extend %_font;
  }
  .dialog-footer {
    margin: 0 -15px -15px;
    padding: 10px 15px;
    border-top: 1px solid $border-color;
    background-color: #f7f7f7;
    .el-button.sure{
      background-color: #31cf86;
      font-size: 14px;
      color: #fff;
    }
  }
}
.checkWrap {
  .pre{
    .xing{
      color: #f03749;
      padding-right: 5px;
    }
    // padding-left: 12px;
  }
  .el-checkbox {
    display: block;
    padding: 0;
    margin-bottom: 10px;
  }
  .el-checkbox + .el-checkbox {
    margin-left: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/permissions/UserPer.vue